module.exports = __webpack_public_path__ + "img/3jAN9InapQI.2781baf7.jpg";